import React, { useState } from "react";
import { SketchPicker } from "react-color";
import { ColorPop, ColorCover,
    PickerWrapper, OuterCircle,
    ColorCircle, SelectedColorPreview,
    MainCircle
} from "./style";
import { Text } from "src/components";

const svgPlus = (
    <svg width="20" height="20" viewBox="0 0 40 40">
        <line x1="20" y1="8" x2="20" y2="32" stroke="#D8DEEC" strokeWidth="4" strokeLinecap="round"/>
        <line x1="8" y1="20" x2="32" y2="20" stroke="#D8DEEC" strokeWidth="4" strokeLinecap="round"/>
    </svg>
);

const ColorPickerTrigger = ({ color, onChange, width, height }) => {
    const [isPickerVisible, setIsPickerVisible] = useState(false);

    const togglePicker = () => {
        setIsPickerVisible(prev => !prev);
    };

    const handleClose = () => {
        setIsPickerVisible(false);
    };

    return (
        <PickerWrapper>
            <div style={{ display: "flex", alignItems: "center", gap: "30px", marginBottom: "10px" }}>
                <MainCircle>
                    <OuterCircle onClick={togglePicker}>
                        <ColorCircle width={width} height={height}>
                            <Text margin="13px 10px 10px 10px" >
                                {svgPlus}
                            </Text>
                        </ColorCircle>
                    </OuterCircle>
                </MainCircle>

                <SelectedColorPreview color={color} />
            </div>

            {isPickerVisible && (
                <ColorPop>
                    <ColorCover onClick={handleClose} />
                    <SketchPicker color={color} onChange={onChange} />
                </ColorPop>
            )}
        </PickerWrapper>
    );
};

export default ColorPickerTrigger;
